<template>
  <v-timeline
    id="vetalfa-algorithms-timeline"
    class="ma-0 pa-0"
    align-top
    dense
  >
    <slot name="customNodes"></slot>
    <algorithm-node
      v-for="node in nodes"
      :key="`algorithm-node-${node.level}`"
      :level="node.level"
      :headerHeightOffset="headerHeightOffset"
      :dialogContainer="dialogContainer"
      @formatTimelineHeight="formatTimelineHeight"
      class="ma-0 pa-0 py-2"
    ></algorithm-node>
    <v-btn
      fab
      color="primary"
      bottom
      right
      fixed
      @click="scrollToTop"
      v-if="scrollTop > 100 && scrollTopBtn"
    >
      <v-icon color="white"> {{ mdiArrowUp }} </v-icon>
    </v-btn>
  </v-timeline>
</template>

<style>
.v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
  left: 16px;
  top: var(--pseudo-timeline-top);
  right: initial;
  height: var(--pseudo-timeline-height);
}
.v-timeline--dense .v-timeline-item {
  padding-left: 8px !important;
}
.v-timeline--dense .v-timeline-item__body {
  max-width: 100%;
}
.v-timeline-item__divider {
  min-width: 16px;
}
.v-timeline-item__dot--small {
  height: 16px;
  width: 16px;
  margin-top: 2px;
}
</style>

<script>
import { mapMutations, mapGetters } from "vuex";
import AlgorithmNode from "../components/AlgorithmNode.vue";
import { mdiArrowUp } from "@mdi/js";
export default {
  name: "Algorithms",
  components: {
    "algorithm-node": AlgorithmNode,
  },
  computed: {
    ...mapGetters("algorithms", ["nodes"]),
  },
  methods: {
    ...mapMutations("algorithms", ["setModels"]),
    handleScroll() {
      this.scrollTop = window.scrollY;
    },
    formatTimelineHeight() {
      setTimeout(() => {
        const root = document.querySelector(":root");
        const totalHeight = document.getElementById(
          "vetalfa-algorithms-timeline"
        ).offsetHeight;
        const lastNode = document.getElementById(
          `algorithm-${this.nodes.length - 1}`
        );
        if (
          lastNode &&
          (this.customNodesNumber == 0 || this.nodes.length >= 1)
        ) {
          root.style.setProperty(
            "--pseudo-timeline-height",
            `${
              this.nodes.length === 1 && this.customNodesNumber == 0
                ? 0
                : totalHeight - lastNode.offsetHeight
            }px`
          );
          root.style.setProperty("--pseudo-timeline-top", "10px");
        } else if (this.customNodesNumber > 0) {
          const node = document.getElementById(
            `algorithm-custom-${this.customNodesNumber}`
          );
          root.style.setProperty(
            "--pseudo-timeline-height",
            `${totalHeight - node.offsetHeight}px`
          );
          root.style.setProperty("--pseudo-timeline-top", "10px");
        }
      }, 300);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  data() {
    return {
      scrollTop: 0,
      mdiArrowUp,
    };
  },
  watch: {
    nodes: {
      handler() {
        this.formatTimelineHeight();
      },
      deep: true,
    },
    triggerFormatTimelineHeight: {
      handler() {
        this.formatTimelineHeight();
      },
      deep: true,
    },
  },
  props: {
    headerHeightOffset: {
      type: Number,
      required: false,
      default: 0,
    },
    scrollTopBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    customNodesNumber: {
      type: Number,
      required: false,
      default: 0,
    },
    triggerFormatTimelineHeight: {
      required: false,
      default: false,
    },
    dialogContainer: {
      required: false,
      default: null,
      type: Boolean,
    },
  },
  created() {},
  mounted() {
    window.removeEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.handleScroll.bind(this));
    this.$nextTick(() => {
      this.formatTimelineHeight();
    });
  },
};
</script>